import { type License } from "@clipboard-health/contract-worker-app-bff";
import { ListItemButton, ListItemText, Text } from "@clipboard-health/ui-components";

import { RoleListItemLicensesInfo } from "./LicensesInfo";

interface RoleListItemProps {
  qualificationLabel: string;
  licenses: License[];
  requiresLicense: boolean;
  onClick: () => void;
}

export function RoleListItem(props: RoleListItemProps) {
  const { qualificationLabel, licenses, requiresLicense, onClick } = props;

  return (
    <ListItemButton divider onClick={onClick}>
      <ListItemText
        disableTypography
        primary={
          <Text semibold variant="h6" sx={{ marginBottom: 1 }}>
            {qualificationLabel}
          </Text>
        }
        secondary={
          <RoleListItemLicensesInfo licenses={licenses} requiresLicense={requiresLicense} />
        }
        sx={{ paddingLeft: 3 }}
      />
    </ListItemButton>
  );
}
